import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import Line from "../images/line.svg"
// import "../style/style.css"


const BlogHero = (props) => (
  <div className="uber-hero blog-hero">
    <GatsbyImage image={props.img} />
    <div className="uber-headline blog-headline">
      <h1>{props.title}</h1>
    </div>
    <div
      className="uber-slogan"
      dangerouslySetInnerHTML={{
        __html: props.slogan,
      }}
    >
    </div>
  </div>
)

export default BlogHero